// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorTooltip_errorContainer__2YIvL","errorTooltip":"ErrorTooltip_errorTooltip__Q1VsL","fadeIn":"ErrorTooltip_fadeIn__ikcDW"};